/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Config } from '../models';
// @ts-ignore
import type { CreateConfigRequestConfig } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateConfigRequest } from '../models';
/**
 * ConfigsAPIApi - axios parameter creator
 * @export
 */
export const ConfigsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new config for the given cluster.
         * @summary Creates config for the given cluster.
         * @param {string} configOrganizationId 
         * @param {string} configClusterId 
         * @param {CreateConfigRequestConfig} createConfigRequestConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPICreateConfig: async (configOrganizationId: string, configClusterId: string, createConfigRequestConfig: CreateConfigRequestConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configOrganizationId' is not null or undefined
            assertParamExists('configsAPICreateConfig', 'configOrganizationId', configOrganizationId)
            // verify required parameter 'configClusterId' is not null or undefined
            assertParamExists('configsAPICreateConfig', 'configClusterId', configClusterId)
            // verify required parameter 'createConfigRequestConfig' is not null or undefined
            assertParamExists('configsAPICreateConfig', 'createConfigRequestConfig', createConfigRequestConfig)
            const localVarPath = `/application-automation/v1alpha/organizations/{config.organization_id}/clusters/{config.cluster_id}/configurations`
                .replace(`{${"config.organization_id"}}`, encodeURIComponent(String(configOrganizationId)))
                .replace(`{${"config.cluster_id"}}`, encodeURIComponent(String(configClusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConfigRequestConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete config for the given cluster.
         * @summary Delete cluster config including its public key.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [force] If true, skip the integration guard check and force deletion.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIDeleteClusterConfig: async (organizationId: string, clusterId: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('configsAPIDeleteClusterConfig', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('configsAPIDeleteClusterConfig', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/configurations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get config for the given cluster.
         * @summary Get config for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIGetConfig: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('configsAPIGetConfig', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('configsAPIGetConfig', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/configurations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing config for the given cluster.
         * @summary Updates config for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {UpdateConfigRequest} updateConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIUpdateConfig: async (organizationId: string, clusterId: string, updateConfigRequest: UpdateConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('configsAPIUpdateConfig', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('configsAPIUpdateConfig', 'clusterId', clusterId)
            // verify required parameter 'updateConfigRequest' is not null or undefined
            assertParamExists('configsAPIUpdateConfig', 'updateConfigRequest', updateConfigRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/configurations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigsAPIApi - functional programming interface
 * @export
 */
export const ConfigsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new config for the given cluster.
         * @summary Creates config for the given cluster.
         * @param {string} configOrganizationId 
         * @param {string} configClusterId 
         * @param {CreateConfigRequestConfig} createConfigRequestConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configsAPICreateConfig(configOrganizationId: string, configClusterId: string, createConfigRequestConfig: CreateConfigRequestConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Config>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configsAPICreateConfig(configOrganizationId, configClusterId, createConfigRequestConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigsAPIApi.configsAPICreateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete config for the given cluster.
         * @summary Delete cluster config including its public key.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [force] If true, skip the integration guard check and force deletion.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configsAPIDeleteClusterConfig(organizationId: string, clusterId: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configsAPIDeleteClusterConfig(organizationId, clusterId, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigsAPIApi.configsAPIDeleteClusterConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get config for the given cluster.
         * @summary Get config for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configsAPIGetConfig(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Config>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configsAPIGetConfig(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigsAPIApi.configsAPIGetConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing config for the given cluster.
         * @summary Updates config for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {UpdateConfigRequest} updateConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configsAPIUpdateConfig(organizationId: string, clusterId: string, updateConfigRequest: UpdateConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Config>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configsAPIUpdateConfig(organizationId, clusterId, updateConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigsAPIApi.configsAPIUpdateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigsAPIApi - factory interface
 * @export
 */
export const ConfigsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigsAPIApiFp(configuration)
    return {
        /**
         * Create a new config for the given cluster.
         * @summary Creates config for the given cluster.
         * @param {ConfigsAPIApiConfigsAPICreateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPICreateConfig(requestParameters: ConfigsAPIApiConfigsAPICreateConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Config> {
            return localVarFp.configsAPICreateConfig(requestParameters.configOrganizationId, requestParameters.configClusterId, requestParameters.createConfigRequestConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete config for the given cluster.
         * @summary Delete cluster config including its public key.
         * @param {ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIDeleteClusterConfig(requestParameters: ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configsAPIDeleteClusterConfig(requestParameters.organizationId, requestParameters.clusterId, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * Get config for the given cluster.
         * @summary Get config for the given cluster.
         * @param {ConfigsAPIApiConfigsAPIGetConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIGetConfig(requestParameters: ConfigsAPIApiConfigsAPIGetConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Config> {
            return localVarFp.configsAPIGetConfig(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing config for the given cluster.
         * @summary Updates config for the given cluster.
         * @param {ConfigsAPIApiConfigsAPIUpdateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configsAPIUpdateConfig(requestParameters: ConfigsAPIApiConfigsAPIUpdateConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Config> {
            return localVarFp.configsAPIUpdateConfig(requestParameters.organizationId, requestParameters.clusterId, requestParameters.updateConfigRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for configsAPICreateConfig operation in ConfigsAPIApi.
 * @export
 * @interface ConfigsAPIApiConfigsAPICreateConfigRequest
 */
export interface ConfigsAPIApiConfigsAPICreateConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPICreateConfig
     */
    readonly configOrganizationId: string

    /**
     * 
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPICreateConfig
     */
    readonly configClusterId: string

    /**
     * 
     * @type {CreateConfigRequestConfig}
     * @memberof ConfigsAPIApiConfigsAPICreateConfig
     */
    readonly createConfigRequestConfig: CreateConfigRequestConfig
}

/**
 * Request parameters for configsAPIDeleteClusterConfig operation in ConfigsAPIApi.
 * @export
 * @interface ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest
 */
export interface ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIDeleteClusterConfig
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIDeleteClusterConfig
     */
    readonly clusterId: string

    /**
     * If true, skip the integration guard check and force deletion.
     * @type {boolean}
     * @memberof ConfigsAPIApiConfigsAPIDeleteClusterConfig
     */
    readonly force?: boolean
}

/**
 * Request parameters for configsAPIGetConfig operation in ConfigsAPIApi.
 * @export
 * @interface ConfigsAPIApiConfigsAPIGetConfigRequest
 */
export interface ConfigsAPIApiConfigsAPIGetConfigRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIGetConfig
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIGetConfig
     */
    readonly clusterId: string
}

/**
 * Request parameters for configsAPIUpdateConfig operation in ConfigsAPIApi.
 * @export
 * @interface ConfigsAPIApiConfigsAPIUpdateConfigRequest
 */
export interface ConfigsAPIApiConfigsAPIUpdateConfigRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIUpdateConfig
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ConfigsAPIApiConfigsAPIUpdateConfig
     */
    readonly clusterId: string

    /**
     * 
     * @type {UpdateConfigRequest}
     * @memberof ConfigsAPIApiConfigsAPIUpdateConfig
     */
    readonly updateConfigRequest: UpdateConfigRequest
}

/**
 * ConfigsAPIApi - object-oriented interface
 * @export
 * @class ConfigsAPIApi
 * @extends {BaseAPI}
 */
export class ConfigsAPIApi extends BaseAPI {
    /**
     * Create a new config for the given cluster.
     * @summary Creates config for the given cluster.
     * @param {ConfigsAPIApiConfigsAPICreateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsAPIApi
     */
    public configsAPICreateConfig(requestParameters: ConfigsAPIApiConfigsAPICreateConfigRequest, options?: RawAxiosRequestConfig) {
        return ConfigsAPIApiFp(this.configuration).configsAPICreateConfig(requestParameters.configOrganizationId, requestParameters.configClusterId, requestParameters.createConfigRequestConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete config for the given cluster.
     * @summary Delete cluster config including its public key.
     * @param {ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsAPIApi
     */
    public configsAPIDeleteClusterConfig(requestParameters: ConfigsAPIApiConfigsAPIDeleteClusterConfigRequest, options?: RawAxiosRequestConfig) {
        return ConfigsAPIApiFp(this.configuration).configsAPIDeleteClusterConfig(requestParameters.organizationId, requestParameters.clusterId, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get config for the given cluster.
     * @summary Get config for the given cluster.
     * @param {ConfigsAPIApiConfigsAPIGetConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsAPIApi
     */
    public configsAPIGetConfig(requestParameters: ConfigsAPIApiConfigsAPIGetConfigRequest, options?: RawAxiosRequestConfig) {
        return ConfigsAPIApiFp(this.configuration).configsAPIGetConfig(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing config for the given cluster.
     * @summary Updates config for the given cluster.
     * @param {ConfigsAPIApiConfigsAPIUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsAPIApi
     */
    public configsAPIUpdateConfig(requestParameters: ConfigsAPIApiConfigsAPIUpdateConfigRequest, options?: RawAxiosRequestConfig) {
        return ConfigsAPIApiFp(this.configuration).configsAPIUpdateConfig(requestParameters.organizationId, requestParameters.clusterId, requestParameters.updateConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

